// SearchQueryCache.cs: the last 32 evaluated queries for one corpus, most
// recently used last, so backspacing and chip clicks never score again. A
// new corpus (the list reloaded) starts an empty cache: callers make one per
// corpus.
export const QUERY_CACHE_SIZE = 32

export const createQueryCache = (capacity = QUERY_CACHE_SIZE) => {
  const map = new Map()
  return {
    get: query => {
      if (!map.has(query)) return undefined
      const value = map.get(query)
      map.delete(query)
      map.set(query, value)
      return value
    },
    put: (query, value) => {
      if (map.has(query)) map.delete(query)
      map.set(query, value)
      while (map.size > capacity) map.delete(map.keys().next().value)
    },
    get size() {
      return map.size
    }
  }
}
